// collection used by civicsUtils/collection_manager
define(function() {
	const IpsModelCollection = require('civicsBase/ipsModelCollection');
	const builder = require('civicsUtils/buildUrlParameters');
	const AvailableFeatures = require('civicsUtils/available_features');

	return IpsModelCollection.extend({
		initialize: function(options, urlParameters) {
			// extending the model type for the help collection so it will change the idAttribute to _appId
			// the generic helper will no longer in need because of this dynamic configuration
			this.model = this.model.extend({idAttribute: '_appId'});

			$.extend(this, options);
			this.urlParameters = $.extend(true, {}, urlParameters);
		},
		urlRoot: '/delegate/civics-api/api/',
		url: function() {
			// generate url
			var url = '';
			if ( _.isFunction(this.dataType.url)){
				url = this.urlRoot + this.dataType.url();
			}
			else{
				url = this.urlRoot + this.dataType.url;
			}

			if (this.urlParameters) {
				if(AvailableFeatures.SubtypeFilterParam()){
					this.urlParameters.subtypeFilterParam = true;
				}

				if (this.dataType.fieldMappings) {
					this.urlParameters.fieldMappings = this.dataType.fieldMappings;
				}
				if (this.dataType.type) {
					this.urlParameters.dataType = this.dataType.type;
				}
				url += builder.buildUrlParameters(this.urlParameters)
			}
			if (__DEV__) {
				//console.log('url', url);
			}
			return url;
		},
		parse: function(response) {
			// save responseStatus
			this.responseStatus = response.responseStatus;

			// generate unique id
			var data = IpsModelCollection.prototype.parse(response);
			_.map(data, _.bind(this.generateId, this));

			// map fields
			if (this.dataType.fieldMappings) {
				this.map = this.dataType.fieldMappings;
				_.map(data, _.bind(this.mapField, this));
			}

			// call parse
			if (this.dataType.collectionParse instanceof Function) {
				data = this.dataType.collectionParse(data);
			}
			return data;
		},
		mapField: function(obj, key) {
			var type = typeof obj;
			var found = null;
			if (type !== 'array') {
				for (var i = 0; i < this.map.length; i++) {
					if (key === this.map[i].svcName) {
						found = i;
						break;
					}
				};
			}
			if (type === 'array' || type === 'object') {
				var foundOne = _.map(obj, _.bind(this.mapField, this));
				for (var i = 0; i < foundOne.length; i++) {
					if (foundOne[i] !== null) {
						// add new field to model
						obj[this.map[foundOne[i]].appName] = obj[this.map[foundOne[i]].svcName];
					}
				};
			}
			return found;
		},
		generateId: function(obj, key) {
			// generate unique id and add data type to model
			obj._appId = this.dataType.type + "|" + obj.id;
			obj._dataType = this.dataType.type;
		}
    // this to revisit this
    ,
		setModel: function(model) {
			// make sure we are using generic model so that it has the right id
			this.model = model.extend({idAttribute: '_appId'});
		}
	});
});
